var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emb-testimonial-wrap white section-gap title-gap"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"sec-title text-xl-center"},[_c('h4',[_vm._v(_vm._s(_vm.secTitle))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }